import { render } from "./HomeBaseCollectionRequests.vue?vue&type=template&id=2ac74340"
import script from "./HomeBaseCollectionRequests.vue?vue&type=script&lang=js"
export * from "./HomeBaseCollectionRequests.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__